import { useEffect } from "react";
import Expenses from '../table/Tableexpenses';
import Modal from "../modal/Modalexpenses"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Expenses/>
    
     
     </>
  );
};

export default Dashboard;
